<template>
    <div id="situation" v-if="list != ''">
        <div class="logo"></div>
        <p class="title"><span></span>好友领取情况<span></span></p>
        <div class="container">
            <ul>
                <li v-for="(item, index) in list" :key="index">
                    <img :src="item.avatar" alt="" class="head">
                    <div class="name">{{item.nickname}}</div>
                    <img src="http://shared.youdao.com/dict/market/oxford-activity/imgs/oneVip.png" alt="" class="img_vip" v-if="item.type!=6">
                    <img src="http://shared.youdao.com/dict/market/oxford-activity/imgs/sixVip.png" alt="" class="img_vip" v-if="item.type==6">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'GetedNumber',
        data () {
            return {
                data: {}
            }
        },
        props: {
            list: {}
        }
    }
</script>
<style>
    #situation {
        width: 86%;
        margin: -1.8rem auto 2.15rem;
    }
    .logo {
        width: 1.06rem;
        height: 0.48rem;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/logo.png);
        background-size: 100% 100%;
        margin: 0 auto 0.66rem;
    }
    .title {
        color: #3f3f3f;
        font-size: 0.38rem;
        text-align: center;
        line-height: 0.38rem;
    }
    .title span {
        width: 0.54rem;
        border: 0.01rem solid #bf975e;
        margin-bottom: 0.12rem;
        margin-right: 0.44rem;
        margin-left: 0.44rem;
        display: inline-block;
        text-align: center;
        overflow: hidden;
    }
    #situation .container {
        width: 6.46rem;
        border: 0.02rem solid #d0a76f;
        margin: 0.58rem auto 0.8rem;
        background-size: 100%;
        overflow: hidden;
        background: -moz-linear-gradient(top, #f9f9f8 0%, #ebdcc8 100%);
        background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f9f9f8), color-stop(100%,#ebdcc8));
        background: -webkit-linear-gradient(top, #f9f9f8 0%,#ebdcc8 100%);
        background: -o-linear-gradient(top, #f9f9f8 0%,#ebdcc8 100%);
        background: -ms-linear-gradient(top, #f9f9f8 0%,#ebdcc8 100%);
        background: linear-gradient(to bottom, #f9f9f8 0%,#ebdcc8 100%);
    }
    .head {
        width: 1.12rem;
        height: 1.12rem;
        border-radius: 50%;
        border: 0.04rem solid #bf955d;
        margin: 0 0.2rem 0 0;
        float: left;
    }
    ul {
        overflow: hidden;
        padding-bottom: 0.5rem; 
    }
    ul li {
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
        margin: 0 0 0.5rem 0.3rem;
        /* padding: 0.5rem 0 0 0.3rem; */
    }
    ul li:first-child {
        margin-top: 0.5rem;
    }
    .name {
       font-size: 0.34rem;
       line-height: 0.33rem;
       color: #c4aa89;
       margin: 0.16rem 0 0.36rem;
    }
    .img_vip {
        width: 4.333rem;
    }
</style>



// WEBPACK FOOTER //
// GetedNumber.vue?492518c0